import { getMonetateExperience } from './getMonetateExperience';

export const getMonetateParams = (features, partialExperienceName) =>
  getMonetateExperience(features, partialExperienceName)?.parameters || {};

export const getMonetateParamsValue = (
  features,
  partialExperienceName,
  paramName = ''
) => {
  const parameters =
    getMonetateExperience(features, partialExperienceName)?.parameters || {};

  return parameters?.[paramName] ?? '';
};

export const getExperiencesWithMatchingParamValues = (
  features,
  paramName = '',
  paramValue = ''
) => {
  return (
    features?.monetateExperiences?.filter(({ parameters }) =>
      parameters?.[paramName]
        ?.split('|')
        .some(value => value.toLowerCase() === paramValue.toLowerCase())
    ) || []
  );
};
